function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: "50%",
  cy: "50%",
  r: 17,
  fill: "#a3a3a3"
});

function SvgActivityPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 34 34",
    width: 35,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6, 20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-370.30867346939, -444.17602040816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.30867346939 444.17602040816 C370.30867346939 444.17602040816 381 455.83928571429 394.12117346939 444.17602040816",
    style: {
      strokeWidth: 3,
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityPlaceholder);
export default __webpack_public_path__ + "static/media/activity-placeholder.1e3148f5.svg";
export { ForwardRef as ReactComponent };